import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { MERGE_TRANSACTION_KEYPAD_TOP_LABEL } from 'src/common/helpers/config';
import { IButton } from 'src/common/interfaces/IButton';
import Keypad from 'src/keypad/components/keypad';
import { styles } from './merge-transaction-styles';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import BaseButton from 'src/common/components/base-button';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import { useTranslation } from 'react-i18next';

type Props = IMergeTransactionProps;

export const showMergeTransactionPage = (props: Props, onScan: ScannedDataHandler): void => {
  setHomePage(<MergeTransaction {...props} />, onScan);
};

const MergeTransaction: React.FC<Props> = (props: IMergeTransactionProps): JSX.Element => {
  const { t } = useTranslation();
  const classes = styles();
  const keypadSubmitButton: IButton = {
    label: t('Ok'),
    onClick: props.onSubmit,
    testId: 'keypad-ok-button',
  };

  return (
    <Grid item className={`${classes.background} fullHeight flexFull`}>
      <Grid
        container
        direction='column'
        className={`fullWidth ${classes.mergeTransactionContainer} fullHeight`}
      >
        <Grid item>
          <Typography className={classes.title}>{t('Merge_Transaction_Command')}</Typography>
          <Grid item xs={1}>
            <Typography className={classes.titleBar} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid className={classes.content} container style={{ flex: '1 1 0' }}>
            <Grid container className={classes.descriptionContainer}>
              <Typography className={classes.descriptionLabel}>
                {t('MergeTransactionDescription')}
              </Typography>
            </Grid>
            <Grid container>
              <Grid item>
                <BaseButton
                  id='merge-trans-add-item-close'
                  data-testid='cancel-button'
                  buttonType='white'
                  onClick={props.onCancel}
                >
                  {t('Cancel')}
                </BaseButton>
              </Grid>
              <Grid item>
                <BaseButton
                  data-testid='list-button-merge-transaction'
                  onClick={props.onList}
                  className={classes.transactionListButton}
                >
                  <span className='label'> {t('TransactionList')}</span>
                </BaseButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Keypad
              visible={true}
              keyboardId={'merge-transaction'}
              topLabelText={MERGE_TRANSACTION_KEYPAD_TOP_LABEL}
              submitButton={keypadSubmitButton}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface IMergeTransactionProps {
  onCancel: () => void;
  onList: () => void;
  onSubmit: (barcode: string) => void;
}

export default MergeTransaction;
